import React, { Fragment } from "react"
import { Link as GatsbyLink } from "gatsby"

import { withArticleNavigation } from "./withArticleNavigation"
import { Icon } from "../../Icon/Icon"
import { StyledColumn } from "../../Styled/Column"
import { Small } from "../../Styled/Text"
import { Navigation, Button, ButtonText, IconWrapper, Items, Item, Link, Menu, Trigger } from "./ArticleNavigationStyles"
import { IconCircle } from "../../Search/Filter/List/SearchFilterListStyles"

export const ArticleNavigation = withArticleNavigation(
  ({ active, handleActive, handleOpen, handleRegister, locales, navigation, open, accountType }): JSX.Element => (
    <Navigation active={active}>
      <Trigger active={active} onClick={handleActive} title={locales?.additionalMenu}>
        <span>{locales?.additionalMenu}</span>
        <Icon name={active ? `cross` : `chevronDown`} width={active ? 8 : 10} />
      </Trigger>
      <Menu active={active}>
        {navigation?.map(({ title, items }) => (
          <Fragment key={title}>
            <Button as={`button`} items={`center`} onClick={open !== title ? () => handleOpen(title) : null} title={title}>
              <StyledColumn width={`grow`}>
                <ButtonText align={`left`}>
                  <strong>{title}</strong>
                </ButtonText>
              </StyledColumn>
              <StyledColumn width={`no-shrink`}>
                <IconWrapper active={open === title}>
                  <Icon name={`chevronDown`} width={16} />
                </IconWrapper>
              </StyledColumn>
            </Button>
            {open === title && (
              <Items>
                {items?.map(({ active, slug: { current }, title, url, visibility }) => (
                  <Item key={current} active={active}>
                    {!visibility || accountType?.includes(visibility) ? (
                      <Link as={GatsbyLink} title={title} to={url} colour={`inherit`}>
                        {title}
                      </Link>
                    ) : (
                      <Link items={`center`} justify={`start`} onClick={handleRegister} active={active}>
                        <IconCircle locked={true}>
                          <Icon name={`lock`} width={14} />
                        </IconCircle>
                        <Small large normal>
                          {title}
                        </Small>
                      </Link>
                    )}
                  </Item>
                ))}
              </Items>
            )}
          </Fragment>
        ))}
      </Menu>
    </Navigation>
  )
)
